import { MSG_CODE } from '../constants';
import {
    getSceneObject,
    loadSceneObjectFromNetwork,
    ReceiveForceStopScrenSharingMessage,
    updateAnimationModelActionFromNetwork,
    updateSceneObjectFromNetwork,
    updateVideoStatusToProjectorNetwork,
    deleteSceneObjectFromNetwork,
    setOrbitToSceneObjectRemotePlayer,
    getCurrentSceneId
} from './objectsModuleController';
import {
    getCameraPositionAndRotation,
    getSetRemoteActor,
    remoteAllLinkpads,
    startFitToObject,
    updateLinkpad,
    loadScene,
    // enableLinkpadInRemoteUsers
} from "./viewerModuleController";
import {
    getPlayerHeight,
    enablePlayerMovementAndRotation,
    focusView,
    generateNewNavmesh
} from "./navigationModuleController";
import { actionHandler, receiveEnableMirrorFollowme } from './actionModuleController';
import { JoinChannelAndPublishTracks } from "./communicationModuleController"
import { searchActorByUserId } from '../../../networking/src';
import { loadActions } from './actionModuleController';
import { ACTION_CODE } from '../../../action/src/actionConstants';
import { receiveMessageMonitoring, sendMessageMonitoring } from './analyticsController';

let networkingModule = null;
let networkingLocalData = {};
let options;

let roomSpawn = {};

var timeConnection;

var quadrants = [];
var currentQuadrant = null;

const spawnQueue = [];
let isProcessingSpawnQueue = false;

export var myActorConnected = false;

let events = {};


export var networkingSubscribe = (_event, listener) => {
    if (!events[_event]) {
        events[_event] = [];
    }
    events[_event].push(listener);
}

let emitEvent = (_event, data) => {
    if (events[_event]) {
        events[_event].forEach((listener) => {
            listener(data);
        });
    }
}

export function initNetWorkingModule(_options) {
    return new Promise((resolve, reject) => {

        options = _options;
        networkingModule = options.modules.networkingModule;

        networkingModule.init({ apikeys: options.apikeys }).then(resolve).catch(reject);

        networkingModule.on(networkingModule.EVENT.JOINED_LOBBY, onJoinedLobby);
        networkingModule.on(networkingModule.EVENT.ACTOR_JOIN, onActorJoin);
        networkingModule.on(networkingModule.EVENT.ACTOR_LEAVE, onActorLeave);
        networkingModule.on(networkingModule.EVENT.ERROR, onNetworkError);
        networkingModule.on(networkingModule.EVENT.RECEIVE_MESSAGE, networkingReceiveMessage);
        networkingModule.on(networkingModule.EVENT.SEND_MESSAGE_MONITORING, sendMessageMonitoring);
        networkingModule.on(networkingModule.EVENT.RECEIVE_MESSAGE_MONITORING, receiveMessageMonitoring);
        // networkingModule.on(networkingModule.EVENT.ROOM_PROPERTIES_CHANGE, onRoomPropertiesChange); 

    });
}


export function initNetworkingWithoutModule(_options) {
    return new Promise((resolve, reject) => {
        options = _options;
        myActorConnected = true;
        emitEvent('myActorConnected', {});
        resolve();
    });
}

export function connectToRoom() {
    networkingModule.connectToMaster();
}

export function setRoomSpawn(_spawnPositions) {
    roomSpawn = _spawnPositions;
}

export function onJoinedLobby() {
    networkingModule.joinRoom(options.roomOptions.roomID);
}

function onActorJoin(actor) {
    if (actor.isLocal) {
        networkingLocalData.userId = actor.userId;
        networkingLocalData.agoraUserId = options.userOptions.userId;

        var actorData = {
            ...options.userOptions,
            userId: options.userOptions.userId,
            agoraUserId: options.userOptions.userId,
            userName: options.userOptions.userName,
            photonUserId: actor.userId,
            nickName: options.userOptions.nickName,
            status: "loading",
            focus: true,
        }
        networkingModule.setActorCustomProperty(actor, "userData", actorData);

        var users = networkingModule.getRoomCustomProperty("users");
        if (users) {
            users = users.filter(user => user.agoraUserId != options.userOptions.userId);
            users.push(networkingLocalData);
        } else {
            users = [networkingLocalData];
        }
        networkingModule.setRoomCustomProperty("users", users);

        // if (options.rendererOptions.useOffscreen) {
        //     //spawn
        //     // spawnnLocalUser(actor);
        // } else {
        //     //TODO: send with out offscreen            
        // }

        // // setTimeout(() => {
        // //     instanceRoomActors();
        // // }, 1000);

        myActorConnected = true;
        emitEvent('myActorConnected', {});

    } else {
        // setTimeout(() => {
        //     var agoraRemoteUser = getAgoraUserIdByPhotoId(actor.userId);
        //     var users = networkingModule.getRoomCustomProperty("users");
        //     console.log(users);

        //     if (users) {
        //         var userFound = users.find(user => user.agoraUserId == agoraRemoteUser.agoraUserId && user.agoraUserId == options.userOptions.agoraUserId);
        //         if (userFound) {
        //             var data = {
        //                 code: "onActorNewSession",
        //             }
        //             options.callbacks.defaultResponse(data);
        //         }
        //     }
        // }, 500);

        // let msg = {
        //     code: MSG_CODE.NETWORKING_REMOTE_USER_JOINNED,
        //     data: {
        //         userId: actor.userId
        //     }
        // }

        // sendMessageToOffscreen(msg);
        // emitEvent('newRemoteActorConnected', actor.userId);
    }

    // setTimeout(() => {
    //     previewActorsOnRoom();
    // }, 1000);
}

function previewActorsOnRoom() {
    if (networkingModule == null) return;

    var actors = networkingModule.getActors();
    var actorsName = [];
    actors.forEach(actor => {
        var userData = networkingModule.getActorCustomProperty(actor, "userData");
        actorsName.push({
            // UserName: userData.nickName ? userData.nickName : "LinkRoom", 
            userName: userData ? userData.nickName !== "" ? userData.nickName : userData.userName : "LinkRoom",
            userPhotonId: userData.photonUserId != undefined ? userData.photonUserId : "photon user Id",
            userId: userData.userId != undefined ? userData.userId : "user id",
            status: userData.status != undefined ? userData.status : "ready",
            focus: userData.focus != undefined ? userData.focus : true
        });
    })
    // console.table(actorsName);
}


export function getPhotonIdByAgoraUserId(agoraUserId) {
    var userFound = null
    if (networkingModule) {
        let users = networkingModule.getRoomCustomProperty("users");
        if (users) {
            userFound = users.find(user => user.agoraUserId === agoraUserId);
        }
    }
    return userFound;
}

export function getActorPropertyByUserId(userId) {
    let actor = networkingModule.searchActorByUserId(userId);
    if (actor) {
        let actorProperty = networkingModule.getActorCustomProperty(actor, "userData");
        if (actorProperty) {
            return actorProperty;
        }
    }
    return null;
}

export function getAgoraUserIdByPhotoId(photonUserId) {
    var userFound = null
    if (networkingModule) {
        let users = networkingModule.getRoomCustomProperty("users");
        if (users) {
            userFound = users.find(user => user.userId === photonUserId);
        }
    }
    return userFound;
}


function updateSpawnWhenUserLeft(actor) {
    // if (spawn) {
    //     roomSpawn = spawn;
    //     leftFromSpawnPosition(roomSpawn, actor.userId);
    //     networkingModule.setRoomCustomProperty('spawn', roomSpawn);
    // }
    // const spawn = networkingModule.getRoomCustomProperty('spawn');
    // if (spawn) {
    //     roomSpawn = spawn;
    //     leftFromSpawnPosition(roomSpawn, actor.userId);
    //     networkingModule.setRoomCustomProperty('spawn', roomSpawn);
    // }
}


function setUserToSpawnPosition(spawn, actor) {
    return {
        userId: actor ? actor.userId : 0,
        position: actor && actor.actorNr < spawn.pos.length ? spawn.pos[actor.actorNr - 1] : spawn.pos[0],
        target: spawn.target
    };
}

function leftFromSpawnPosition(spawn, userId) {

    // for (let i = 0; i < spawn.pos.length; i++) {
    //     const pos = spawn.pos[i];
    //     if (pos.userId == userId) {
    //         pos.userId = null;
    //         break;
    //     }
    // }
}

function sendMessageToOffscreen(msg) {
    if (options.rendererOptions.useOffscreen) {
        options.workers.offscreenCanvasWorker.postMessage(msg);
    } else {
        //TODO: send with out offscreen
    }
}

function onActorLeave(actor) {
    let msg = {
        code: MSG_CODE.NETWORKING_REMOTE_USER_LEAVED,
        data: {
            userId: actor.userId
        }
    }

    var myActor = networkingModule.MyActor();
    var myRoomMasterActorNr = networkingModule.myRoomMasterActorNr();
    if (myActor.actorNr == myRoomMasterActorNr) {
        var users = networkingModule.getRoomCustomProperty("users");
        if (users) {
            users = users.filter(user => user.userId != actor.userId);
            networkingModule.setRoomCustomProperty("users", users);
        }
    }

    updateSpawnWhenUserLeft(actor);
    sendMessageToOffscreen(msg);
    emitActorJoined(actor, false);

    verifyScreenSharingUser(actor.userId)

    setTimeout(() => {
        previewActorsOnRoom();
    }, 1000);
}

function verifyScreenSharingUser(userId) {
    var screenShareInfo = getScreenShareInfoFromRoomProperty();

    if (screenShareInfo) {
        if (screenShareInfo.active) {
            if (screenShareInfo.userId === userId) {
                screenShareInfo.active = false;
                networkingModule.setRoomCustomProperty("screenShareInfo", screenShareInfo);
                updateVideoStatusToProjectorNetwork({ uuid: screenShareInfo.uuid, status: 'stopshare', displayMaterialName: screenShareInfo.displayMaterialName, currentScreenShareData: null })
            }
        }
    }
}

export function disconnect() {
    if (networkingModule) {

        networkingModule.disconnect();
        myActorConnected = false;
    }
}

function onNetworkError(error) {
    remoteAllLinkpads();
    console.error('INTERFACE: detect network error', error);

    var data = {
        code: "OnNetworkError",
        data: error
    }
    options.callbacks.defaultResponse(data);

    // try {

    //     if(networkingModule.isJoinedToRoom())
    //         networkingModule.disconnect();

    //     connected = false;

    // } catch (error) {
    //     console.error('error trying disconnect');
    // }

    // let reconnection = networkingModule.reconnectToMaster();
}

export function networkingReconnection() {
    remoteAllLinkpads();
    let reconnection = networkingModule.reconnectToMaster();
    console.log(reconnection);

}

//Al Messages from Network is manage here
function networkingReceiveMessage(msg) {
    const { code, content, actorNr } = msg;
    let remoteActor;
    //TODO unified all message to sendMessageToOffscreen directly
    switch (code) {
        case MSG_CODE.NETWORKING_SEND_LINKPAD_TRANSFORM:
            sendMessageToOffscreen({ code: MSG_CODE.NETWORKING_RECEIVE_LINKPAD_TRANSFORM, data: content });
            break;
        // case MSG_CODE.NETWORKING_SEND_TRANSFORM_ROTATION:
        //     sendMessageToOffscreen({ code: MSG_CODE.NETWORKING_RECEIVE_TRANSFORM_ROTATION, data: content });
        //     break;
        case MSG_CODE.NETWORKING_ON_USER_SPAWN:
            sendMessageToOffscreen({ code: MSG_CODE.NETWORKING_ON_USER_SPAWN, data: content.data });
            break;
        case MSG_CODE.NETWORKING_ON_SCENE_OBJECTS_CREATE_OR_UPDATE:
            // console.log(content.data);
            var data = content.data;
            const uuid = data.uuid;

            if (data.sceneId == getCurrentSceneId()) {
                // console.log('sceneObject from the same scene');

                const sceneObject = getSceneObject(uuid);
                if (!sceneObject) {
                    //create               
                    loadSceneObjectFromNetwork(data).then(() => {
                        setTimeout(() => {
                            generateNewNavmesh().then();
                        }, 500);
                    });
                } else {
                    //update
                    var action = data.transformDelta.action;
                    var value = data.transformDelta.value;
                    switch (action) {
                        case "position":
                            if (value.x)
                                sceneObject.data.position[0] = value.x;
                            if (value.y)
                                sceneObject.data.position[1] = value.y;
                            if (value.z)
                                sceneObject.data.position[2] = value.z;
                            break;
                        case "rotate":
                            if (value.x)
                                sceneObject.data.rotation[0] = value.x;
                            if (value.y)
                                sceneObject.data.rotation[1] = value.y;
                            if (value.z)
                                sceneObject.data.rotation[2] = value.z;
                            break;
                        case "scale":
                            if (value.x)
                                sceneObject.data.scale[0] = value.x;
                            if (value.y)
                                sceneObject.data.scale[1] = value.y;
                            if (value.z)
                                sceneObject.data.scale[2] = value.z;
                            break;
                    }
                    updateSceneObjectFromNetwork(sceneObject).then();
                }
            } else {
                console.log('sceneObject from a different scene');
            }
            break;
        // case MSG_CODE.NETWORKING_RETURN_SPAWN_TO_USER_JOINNED:
        //     sendMessageToOffscreen({ code: MSG_CODE.NETWORKING_RETURN_SPAWN_TO_USER_JOINNED, data: content.data });
        //     break;

        case MSG_CODE.NETWORKING_ON_SCENE_OBJECTS_DELETE:
            deleteSceneObjectFromNetwork(content.data);
            break;

        case MSG_CODE.ACTION_SEND_ORDER:
            actionHandler(content);
            break;

        case MSG_CODE.ACTION_LOOKTO_ORDER:
            actionHandler(content);
            break;

        case MSG_CODE.ROOM_USER_SPAWN_SETUP:
            console.log("CREATE A NEW USER WHO IS CONNECTING", actorNr);
            setRemoteUserSpawnOffscreen(content);
            saveVideoProgressInRoomProperty();
            remoteActor = networkingModule.searchActorByActorNr(actorNr);
            emitActorJoined(remoteActor, true);

            respondUserSpawnConnected(actorNr);
            break;

        case MSG_CODE.RESPOND_ROOM_USER_SPAWN_SETUP:
            console.log("LIST THE USER IN THE QUEUE", actorNr);
            enqueueRemoteUserSpawn(content, actorNr);
            break;

        case MSG_CODE.NETWORKING_VIDEO_STATUS_PROJECTOR:
            updateVideoStatusToProjectorNetwork(content.data);
            break;

        case MSG_CODE.FORCE_STOP_SCREEN_SHARING:
            // updateVideoStatusToProjectorNetwork(content.data);
            ReceiveForceStopScrenSharingMessage(content.data);
            break;

        // RESERVED_NETWORK_MESSAGES 
        case MSG_CODE.VIP_GUEST_PLACE_IN_POSITION_RQ:
            console.log(`===content====`);
            console.log(content);
            const vipCoordinates = content.hostCoordinates;
            const fanCoordinates = content.guestCoordinates;
            //MOVE TO POSITION
            remoteActor = networkingModule.searchActorByActorNr(actorNr);

            if (!vipCoordinates.position) vipCoordinates.position = [8, 1.6, 0];
            if (!vipCoordinates.rotation) vipCoordinates.rotation = [0, 90, 0];

            let userId = remoteActor.userId;

            var data = {
                code: "onStartMeeting",
                data: content.remainingTime
            }

            options.callbacks.defaultResponse(data);

            getSetRemoteActor({ data: { userId, position: vipCoordinates.position, rotation: vipCoordinates.rotation } });
            startMeeting(userId, fanCoordinates, vipCoordinates);

            break;

        case MSG_CODE.VIP_GUEST_SEND_REMAINING_TIME:
            console.log(`===content====`);
            console.log(content);

            var data = {
                code: "onExtendCallTime",
                data: content.remainingTime
            }

            options.callbacks.defaultResponse(data);
            break;

        case MSG_CODE.SEND_MESSAGE_TO_PLAYER:
            console.log(`===content====`);
            console.log(content);

            var data = {
                code: MSG_CODE.SEND_MESSAGE_TO_PLAYER,
                data: content
            }

            options.callbacks.defaultResponse(data);
            break;

        case MSG_CODE.ROOM_EVENT:
            console.log(`===content====`);
            console.log(content);

            var data = {
                code: MSG_CODE.ROOM_EVENT,
                data: content
            }

            options.callbacks.defaultResponse(data);
            break;
        case MSG_CODE.UPDATE_LINKPAD_NAME:
            // console.log(content);
            updateLinkpad(content);
            break;
        case MSG_CODE.ACTION_ORBIT_SCENEOBJECT:
            // console.log(content);
            setOrbitToSceneObjectRemotePlayer(content).then(() => {
                let msg = {
                    code: MSG_CODE.ACTION_ORBIT_SCENEOBJECT_UI,
                    data: {
                        uuid: content
                    }
                }
                options.callbacks.defaultResponse(msg);
            });

            break;

        case MSG_CODE.ACTION_ANIMATION_MODEL:
            updateAnimationModelActionFromNetwork(content);
            break;
        case MSG_CODE.CHANGE_REMOTE_USER_SCENE:
            let msg = {
                code: MSG_CODE.REMOTE_CHANGE_SCENE,
                data: {
                    sceneId: content
                }
            }
            options.callbacks.defaultResponse(msg);
            break;

        case MSG_CODE.MIRROR_FOLLOWME:
            receiveEnableMirrorFollowme(content);
            break;

        // case MSG_CODE.NETWORKING_SEND_ENABLE_LINKPAD_IN_REMOTE_USERS:
        //     console.log("AQUI ES DONDE DEBEMOS DE CREAR AL USUARIO REMOTO");

        //     console.log("===content====");
        //     console.log(content);
        //     enableLinkpadInRemoteUsers(content);


        //     break;
        default:
            break;
    }
}


function enqueueRemoteUserSpawn(content, actorNr) {
    spawnQueue.push({ content, actorNr });
    processSpawnQueue();
}

function processSpawnQueue() {
    if (isProcessingSpawnQueue || spawnQueue.length === 0) return;

    isProcessingSpawnQueue = true;

    const { content, actorNr } = spawnQueue.shift();
    console.log("CREATE THE REMOTE USER WHO IS ALREADY IN THE ROOM", actorNr);

    setRemoteUserSpawnOffscreen(content);
    saveVideoProgressInRoomProperty();
    const remoteActor = networkingModule.searchActorByActorNr(actorNr);
    emitActorJoined(remoteActor, true);

    setTimeout(() => {
        isProcessingSpawnQueue = false;
        processSpawnQueue();
    }, 1000);
}

export function sendNetworkingUpdateLinkpad(data) {

    if (networkingModule == null) return;
    data.data.local = false;
    data.data.userId = networkingLocalData.userId;

    if (data.data.type == "UpdateName") {
        var actorProperty = getActorPropertyByUserId(networkingLocalData.userId);
        if (actorProperty) {
            let actor = networkingModule.searchActorByUserId(networkingLocalData.userId);
            actorProperty.nickName = data.data.name;
            networkingModule.setActorCustomProperty(actor, "userData", actorProperty);
        }
    }

    networkingModule.sendMessage(MSG_CODE.UPDATE_LINKPAD_NAME, data);
}

export function sendAnimationModelActionByNetwork(data) {
    networkingModule.sendMessage(MSG_CODE.ACTION_ANIMATION_MODEL, data);
}
// FUNCTION RESERVED_NETWORK_MESSAGES (OSU)
export function startMeeting(userId, fanPosition, vipPosition) {

    const payload =
    {
        value: ACTION_CODE.NAVIGATE_TO_POSITION,
        position: { x: fanPosition.position[0], y: fanPosition.position[1], z: fanPosition.position[2] },
        positionLook: { x: vipPosition.position[0], y: vipPosition.position[1], z: vipPosition.position[2] }
    };

    JoinChannelAndPublishTracks();
    loadActions(payload);
    enablePlayerMovementAndRotation({ data: { enabled: false } }).then(() => { });

    setTimeout(() => {
        startFitToObject({ data: { userId } });
    }, 1000);
}


export function persistPositionAndRotationOnFocusLoss() {

    if (!networkingModule || myActorConnected == false)
        return;

    getCameraPositionAndRotation().then(({ position, rotation }) => {
        const userId = networkingLocalData.userId;
        let positionConnectedActors = networkingModule.getRoomCustomProperty("positionConnectedActors") || [];
        positionConnectedActors = positionConnectedActors.filter(user => user.userId !== userId);
        positionConnectedActors.push({ userId, position, rotation });
        networkingModule.setRoomCustomProperty("positionConnectedActors", positionConnectedActors);
    });

    updateFocusedActor(false);
}

export function FocusFound() {

    if (!networkingModule)
        return;

    updateFocusedActor(true);
}

function updateFocusedActor(value) {

    focusView({ data: { focus: value } }).then(() => { });

    var myActor = networkingModule ? networkingModule.getLocalActor() : null;
    if (myActor == null) return;

    let actorProperty = networkingModule.getActorCustomProperty(myActor, "userData");

    if (actorProperty) {
        actorProperty.focus = value;
        networkingModule.setActorCustomProperty(myActor, "userData", actorProperty);
    }
}

function setRemoteUserSpawnOffscreen(content) {

    getCameraPositionAndRotation().then(({ position, rotation }) => {
        const userId = networkingLocalData.userId;
        let positionConnectedActors = networkingModule.getRoomCustomProperty("positionConnectedActors") || [];
        positionConnectedActors = positionConnectedActors.filter(user => user.userId !== userId);
        positionConnectedActors.push({ userId, position, rotation });
        networkingModule.setRoomCustomProperty("positionConnectedActors", positionConnectedActors);

        sendMessageToOffscreen({ code: MSG_CODE.REMOTE_USER_SPAWN_SETUP_OFF_SCREEN, data: content.data });
    });

    setTimeout(() => {
        previewActorsOnRoom();
    }, 1000);
}

// export async function instanceRoomActors() {


//     const actorsInRoom = networkingModule.getRoomOtherActors();
//     for (const key in actorsInRoom) {
//         if (Object.prototype.hasOwnProperty.call(actorsInRoom, key)) {
//             const actor = actorsInRoom[key];

//             if (actor) {
//                 let msg = {
//                     code: MSG_CODE.NETWORKING_REMOTE_USER_JOINNED,
//                     data: {
//                         userId: actor.userId,
//                     }
//                 }
//                 sendMessageToOffscreen(msg);
//                 setTimeout(() => {
//                     enableLinkpadInRemoteUsers({ data: msg.data });
//                 }, 2000)

//                 await new Promise(resolve => setTimeout(resolve, 1000));
//             }
//         }
//     }
// }

export function saveVideoProgressInRoomProperty() {
    if (!networkingModule)
        return;

    const videoContainer = document.getElementById(options.roomOptions.videoContainer);
    const videos = videoContainer.getElementsByTagName('video');
    const videoData = {};
    for (const video of videos) {
        const id = video.id;
        const currentTime = video.currentTime;
        const isPaused = video.paused;
        videoData[id] = {
            currentTime: currentTime,
            paused: isPaused
        };
    }
    networkingModule.setRoomCustomProperty("videoProgress", videoData);
}

export function getVideoProgressFromRoomProperty(videoId) {
    if (!networkingModule)
        return 0;
    var videoTimes = networkingModule.getRoomCustomProperty("videoProgress");
    if (videoTimes) {
        const elapsedSeconds = (Date.now() - timeConnection) / 1000;
        if (videoTimes[videoId]) {
            if (videoTimes[videoId].paused) {
                return videoTimes[videoId].currentTime
            } else {
                return videoTimes[videoId].currentTime + parseFloat(elapsedSeconds.toFixed(2) + 1);
            }
        } else {
            return 0;
        }
    } else {
        return 0;

    }
}

export function saveScreenShareInfoOnRooomProperty(data) {
    if (!networkingModule)
        return;

    var user = getPhotonIdByAgoraUserId(options.userOptions.userId);
    console.log(user);
    data.userId = user.userId;
    networkingModule.setRoomCustomProperty("screenShareInfo", data);
}

export function getScreenShareInfoFromRoomProperty() {
    if (!networkingModule)
        return;
    return networkingModule.getRoomCustomProperty("screenShareInfo");
}

export function sendForceStopScrenSharingMessage(userId) {
    if (!networkingModule)
        return;


    let code = MSG_CODE.FORCE_STOP_SCREEN_SHARING;
    let actorsNr = null;

    if (userId) {
        var user = getPhotonIdByAgoraUserId(userId)
        let userFound = searchActorByUserId(user.userId);
        actorsNr = [userFound.actorNr];
    }

    if (actorsNr)
        networkingModule.sendMessage(code, { data: "" }, actorsNr);
}

export function setQuadrantData(payload) {

    if (!networkingModule)
        return;

    var data = payload.data;

    currentQuadrant = data.currentQuadrant;

    var q = data.quadrants;
    var quadrantsList = [];
    q.forEach((l, i) => {
        var data = {
            quadrants: l,
            quantity: i == 0 ? 1 : i * 3,
            currentQuantity: 0
        }
        quadrantsList.push(data);
    })

    quadrants = quadrantsList;

    networkingModule.setInterestGroup(currentQuadrant);


    var sizeMinX = data.sizeMinX;
    var sizeMaxX = data.sizeMaxX;
    var sizeMinZ = data.sizeMinZ;
    var sizeMaxZ = data.sizeMaxZ;
    var cellSize = data.cellSize;
    var rows = data.rows;
    var cols = data.cols;
    var maxDistance = data.maxDistance;
    networkingModule.setQuadrantData(sizeMinX, sizeMaxX, sizeMinZ, sizeMaxZ, cellSize, rows, cols, maxDistance);


}

// export function sendEnableLinkpadInRemoteUsers() {

//     if (!networkingModule)
//         return;

//     var myActor = networkingModule ? networkingModule.getLocalActor() : null;

//     const msg = {
//         code: MSG_CODE.NETWORKING_SEND_ENABLE_LINKPAD_IN_REMOTE_USERS,
//         data: {
//             userId: myActor.userId,
//         }
//     }

//     networkingModule.sendMessage(msg.code, msg);
// }


export function sendLinkpadsTransformMessages(msg) {

    if (!networkingModule)
        return;

    let data = { userId: networkingLocalData.userId };

    if (msg.data.type) {
        data.type = msg.data.type;
    }

    if (msg.data.payload) {
        data.payload = msg.data.payload;
    }

    networkingModule.sendMessageByQuadrant(msg.code, data, currentQuadrant);

    var usersPerInterestGroup = networkingModule.getUsersPerInterestGroup();

    if (quadrants != null) {

        for (let index = 0; index < quadrants.length; index++) {
            const quadrant = quadrants[index];
            quadrant.currentQuantity++;

            if (quadrant.currentQuantity >= quadrant.quantity) {

                quadrant.quadrants.forEach(v => {
                    if (usersPerInterestGroup.includes(v))
                        networkingModule.sendMessageByQuadrant(msg.code, data, v);
                })
                quadrant.currentQuantity = 0;
            }
        }
    }

}

export function sendEnableMirrorFollowme(value) {
    if (!networkingModule)
        return;

    let data = { value: value };
    const msg = {
        code: MSG_CODE.MIRROR_FOLLOWME,
        data
    }
    networkingModule.sendMessage(msg.code, msg);
}

export function sendOnSceneObjectCreateOrUpdate(data) {
    if (!networkingModule)
        return;

    const msg = {
        code: MSG_CODE.NETWORKING_ON_SCENE_OBJECTS_CREATE_OR_UPDATE,
        data
    }

    networkingModule.sendMessage(msg.code, msg);
}


export function sendDeleteSceneObjectFromNetwork(data) {
    if (!networkingModule)
        return;

    const msg = {
        code: MSG_CODE.NETWORKING_ON_SCENE_OBJECTS_DELETE,
        data: data
    }

    networkingModule.sendMessage(msg.code, msg);
}

export function sendVideoStatusToProjectorByNetwork(data) {
    if (!networkingModule)
        return;

    const msg = {
        code: MSG_CODE.NETWORKING_VIDEO_STATUS_PROJECTOR,
        data
    }

    networkingModule.sendMessage(msg.code, msg);
}

export function experienceReadyOnNetworking() {
    timeConnection = Date.now();
    var myActor = networkingModule ? networkingModule.getLocalActor() : null;
    var userSpawnPosition = setUserToSpawnPosition(roomSpawn, myActor);

    userSpawnPosition.spawnPosition = userSpawnPosition.position.slice();

    let actorProperty = networkingModule.getActorCustomProperty(myActor, "userData");

    if (actorProperty) {
        actorProperty.status = "ready!";
        networkingModule.setActorCustomProperty(myActor, "userData", actorProperty);
    }

    let msg = {
        code: MSG_CODE.ROOM_USER_SPAWN_SETUP,
        data: userSpawnPosition
    }
    msg.data.userId = myActor.userId;
    msg.data.userName = actorProperty ? actorProperty.nickName !== "" ? actorProperty.nickName : actorProperty.userName : "Linkroom";
    msg.data.photoUrl = actorProperty ? actorProperty.photoUrl : null;

    sendMessageToOffscreen(msg);

    if (options.roomOptions.singleExperience == false) {
        if (myActor) {
            emitActorJoined(myActor, true);
            setTimeout(() => {
                getCameraPositionAndRotation().then(({ position, rotation }) => {

                    msg.data.position = position;
                    msg.data.rotation = rotation;
                    networkingModule.sendMessage(msg.code, msg);
                });
            }, 2000);
        }
    }
}

function respondUserSpawnConnected(actorNr) {

    console.log("RESPOND TO THE USER WHO JUST LOGGED IN", actorNr);


    var myActor = networkingModule ? networkingModule.getLocalActor() : null;
    let actorProperty = networkingModule.getActorCustomProperty(myActor, "userData");

    let msg = {
        code: MSG_CODE.RESPOND_ROOM_USER_SPAWN_SETUP,
        data: {}
    }
    msg.data.userId = myActor.userId;
    msg.data.userName = actorProperty ? actorProperty.nickName !== "" ? actorProperty.nickName : actorProperty.userName : "Linkroom";
    msg.data.photoUrl = actorProperty ? actorProperty.photoUrl : null;

    getCameraPositionAndRotation().then(({ position, rotation }) => {

        msg.data.position = position;
        msg.data.rotation = rotation;
        networkingModule.sendMessage(msg.code, msg, [actorNr]);
    });

}

// function enableRemoteActors() {
//     setTimeout(() => {
//         const actorsInRoom = networkingModule.getRoomOtherActors();
//         var positionConnectedActors = networkingModule.getRoomCustomProperty("positionConnectedActors");

//         if (positionConnectedActors) {
//             for (const key in actorsInRoom) {
//                 if (Object.prototype.hasOwnProperty.call(actorsInRoom, key)) {
//                     const actor = actorsInRoom[key];
//                     var actorFound = positionConnectedActors.find(posActor => posActor.userId == actor.userId);
//                     // console.log("enableRemoteActors");
//                     let actorProperty = networkingModule.getActorCustomProperty(actor, "userData");
//                     //console.log("actorProperty",actorProperty);

//                     let msg = {
//                         code: MSG_CODE.SET_ROOM_USER_SPAWN_SETUP,
//                         data: {
//                             userId: actor.userId,
//                             position: actorFound ? actorFound.position : [0, 1.6, 0],
//                             rotation: actorFound ? actorFound.rotation : [0, 0, 0],
//                             userName: actorProperty ? actorProperty.nickName !== "" ? actorProperty.nickName : actorProperty.userName : "LinkRoom",
//                             // userName: actorProperty ? actorProperty.nickName : "LinkRoom",
//                             photoUrl: actorProperty ? actorProperty.photoUrl : null
//                         }
//                     }
//                     console.log("msg", msg);
//                     sendMessageToOffscreen(msg);
//                     emitActorJoined(actor, true);

//                 }
//             }
//         }
//     }, 1000);
// }

function emitActorJoined(actor, isJoined) {
    var userData = networkingModule.getActorCustomProperty(actor, "userData");
    if (userData) {
        var data = {
            code: isJoined ? "onActorJoined" : "onActorLeft",
            data: userData
        }
        options.callbacks.defaultResponse(data);
    }
}

export function sendMessageViaChat(data) {
    // console.log(`===data====`);
    // console.log(data);
    const { messageId, senderUserId, message, destinataryUserId } = data;
    let code = MSG_CODE.SEND_MESSAGE_TO_PLAYER;
    let actorsNr = null;

    if (destinataryUserId) {
        let destinataryUser = searchActorByUserId(destinataryUserId);
        actorsNr = [destinataryUser.actorNr];
    }

    let payload = {
        messageId,
        message,
        senderUserId
    }

    if (actorsNr) {
        networkingModule.sendMessage(code, payload, actorsNr);
    } else {
        networkingModule.sendMessage(code, payload);
    }
}

export function sendPaymentStatusMessage(msg, destinataryUserId) {
    let code = MSG_CODE.VIP_GUEST_PAYMENT_PROGRESS_STATUS;
    let actorsNr = null;

    if (destinataryUserId) {
        let userFound = searchActorByUserId(destinataryUserId);
        actorsNr = [userFound.actorNr];
    }

    if (actorsNr) {
        networkingModule.sendMessage(code, msg, actorsNr);
    } else {
        networkingModule.sendMessage(code, msg);
    }
}

export function sendRoomEvent(payload, destinataryUserId) {
    let code = MSG_CODE.ROOM_EVENT;
    let actorsNr = null;

    if (destinataryUserId) {
        let userFound = searchActorByUserId(destinataryUserId);
        actorsNr = [userFound.actorNr];
    }

    if (actorsNr) {
        networkingModule.sendMessage(code, payload, actorsNr);
    } else {
        networkingModule.sendMessage(code, payload);
    }
}

export function updateMyActorData(payload) {
    var myActor = networkingModule ? networkingModule.getLocalActor() : null;

    console.log(`===myActor====`);
    console.log(myActor);

    console.log(`===payload====`);
    console.log(payload);

    if (myActor) {
        console.log(`===myActor====`);
        console.log(myActor);
        var actorData = { ...myActor.customProperties.userData, ...payload };
        networkingModule.setActorCustomProperty(myActor, "userData", actorData);

        var data = {
            code: "onActorDataUpdated",
            data: { ...payload, userId: actorData.userId }
        }

        networkingModule.sendMessage(data.code, data.data);
        // options.callbacks.defaultResponse(data);
    }
}